import * as types from 'common/constants';

const initialState = {
  menuList: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  menuItem: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  CustomList: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  CustomItem: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  rejectReasons: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  rejectReason: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  orders: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  order: {
    data: {
      list: []
    },
    loading: false,
    error: null
  },
  createMenu: {
    data: {},
    loading: false,
    error: null
  },
  editMenu: {
    data: {},
    loading: false,
    error: null
  },
  chart: {
    data: {},
    loading: false,
    error: null
  },
  cafeTeriaStatus: {
    data: {},
    loading: false,
    error: null
  },
  upload: {
    data: {},
    loading: false,
    error: null
  }
};

interface Reducer {
  type: string;
  // -- //
  payload: any;
}

const Authenticate = (state = initialState, { type, payload }: Reducer) => {
  switch (type) {
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Menu List cases
     */
    case types.CAFETERIA_MENU.REQUEST:
      return {
        ...state,
        menuList: {
          data: {
            list: state.menuList.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.CAFETERIA_MENU.SUCCESS:
      return {
        ...state,
        menuList: {
          data: {
            list: payload.list ? payload.list : payload,
            totalPages: payload?.totalPages
          },
          loading: false,
          error: null
        }
      };
    case types.CAFETERIA_MENU.FAILURE:
      return {
        ...state,
        menuList: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Create Menu cases
     */
    case types.CAFETERIA_CREATE_MENU.REQUEST:
      return {
        ...state,
        createMenu: { data: {}, loading: true, error: null }
      };
    case types.CAFETERIA_CREATE_MENU.SUCCESS:
      return {
        ...state,
        createMenu: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.CAFETERIA_CREATE_MENU.FAILURE:
      return {
        ...state,
        createMenu: { data: {}, loading: false, error: payload }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Edit Menu cases
     */
    case types.CAFETERIA_EDIT_MENU.REQUEST:
      return {
        ...state,
        editMenu: { data: {}, loading: true, error: null }
      };
    case types.CAFETERIA_EDIT_MENU.SUCCESS:
      return {
        ...state,
        editMenu: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.CAFETERIA_EDIT_MENU.FAILURE:
      return {
        ...state,
        editMenu: { data: {}, loading: false, error: payload }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Edit Menu cases
     */
    case types.CAFETERIA_CHART.REQUEST:
      return {
        ...state,
        chart: { data: {}, loading: true, error: null }
      };
    case types.CAFETERIA_CHART.SUCCESS:
      return {
        ...state,
        chart: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.CAFETERIA_CHART.FAILURE:
      return {
        ...state,
        chart: { data: {}, loading: false, error: payload }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Status cases
     */
    case types.CAFETERIA_STATUS.REQUEST:
      return {
        ...state,
        cafeTeriaStatus: { data: {}, loading: true, error: null }
      };
    case types.CAFETERIA_STATUS.SUCCESS:
      return {
        ...state,
        cafeTeriaStatus: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.CAFETERIA_STATUS.FAILURE:
      return {
        ...state,
        cafeTeriaStatus: { data: {}, loading: false, error: payload }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Upload cases
     */
    case types.CAFETERIA_UPLOAD.REQUEST:
      return {
        ...state,
        upload: { data: {}, loading: true, error: null }
      };
    case types.CAFETERIA_UPLOAD.SUCCESS:
      return {
        ...state,
        upload: {
          data: payload,
          loading: false,
          error: null
        }
      };
    case types.CAFETERIA_UPLOAD.FAILURE:
      return {
        ...state,
        upload: { data: {}, loading: false, error: payload }
      };

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Customization List cases
     */
    case types.MENU_CUSTOMIZATION.REQUEST:
      return {
        ...state,
        CustomList: {
          data: {
            list: state.CustomList.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.MENU_CUSTOMIZATION.SUCCESS:
      return {
        ...state,
        CustomList: {
          data: {
            list: payload.list ? payload.list : payload,
            totalPages: payload?.totalPages
          },
          loading: false,
          error: null
        }
      };
    case types.MENU_CUSTOMIZATION.FAILURE:
      return {
        ...state,
        CustomList: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };

    //** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Customization Detail cases
     */
    case types.MENU_CUSTOMIZATION_DETAIL.REQUEST:
      return {
        ...state,
        CustomItem: {
          data: {
            list: state.CustomItem.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.MENU_CUSTOMIZATION_DETAIL.SUCCESS:
      return {
        ...state,
        CustomItem: {
          data: {
            list: payload.list ? payload.list : payload
          },
          loading: false,
          error: null
        }
      };
    case types.MENU_CUSTOMIZATION_DETAIL.FAILURE:
      return {
        ...state,
        CustomItem: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };

    //** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * reject reasons list cases
     */
    case types.REJECT_REASONS_LIST.REQUEST:
      return {
        ...state,
        rejectReasons: {
          data: {
            list: state.rejectReasons.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.REJECT_REASONS_LIST.SUCCESS:
      return {
        ...state,
        rejectReasons: {
          data: {
            list: payload.list ? payload.list : payload
          },
          loading: false,
          error: null
        }
      };
    case types.REJECT_REASONS_LIST.FAILURE:
      return {
        ...state,
        rejectReasons: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };

    //** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * reject reason cases
     */
    case types.REJECT_REASON_GET_ONE.REQUEST:
      return {
        ...state,
        rejectReason: {
          data: {
            list: state.rejectReason.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.REJECT_REASON_GET_ONE.SUCCESS:
      return {
        ...state,
        rejectReason: {
          data: {
            list: payload.list ? payload.list : payload
          },
          loading: false,
          error: null
        }
      };
    case types.REJECT_REASON_GET_ONE.FAILURE:
      return {
        ...state,
        rejectReason: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };

    //** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---

    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * Menu Item cases
     */
    case types.MENU_MANAGEMENT_DETAIL.REQUEST:
      return {
        ...state,
        menuItem: {
          data: {
            list: state.menuItem.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.MENU_MANAGEMENT_DETAIL.SUCCESS:
      return {
        ...state,
        menuItem: {
          data: {
            list: payload.list ? payload.list : payload,
            totalPages: payload?.totalPages
          },
          loading: false,
          error: null
        }
      };
    case types.MENU_MANAGEMENT_DETAIL.FAILURE:
      return {
        ...state,
        menuItem: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * orders list cases
     */
    case types.ORDERS_LIST.REQUEST:
      return {
        ...state,
        orders: {
          data: {
            list: state.orders.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.ORDERS_LIST.SUCCESS:
      return {
        ...state,
        orders: {
          data: {
            list: payload.list ? payload.list : payload,
            totalPages: payload?.total
          },
          loading: false,
          error: null
        }
      };
    case types.ORDERS_LIST.FAILURE:
      return {
        ...state,
        orders: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };
    /** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
     * orders list detail cases
     */
    case types.ORDERS_DETAIL.REQUEST:
      return {
        ...state,
        order: {
          data: {
            list: state.order.data.list
          },
          loading: true,
          error: null
        }
      };
    case types.ORDERS_DETAIL.SUCCESS:
      return {
        ...state,
        order: {
          data: {
            list: payload.list ? payload.list : payload,
            totalPages: payload?.total
          },
          loading: false,
          error: null
        }
      };
    case types.ORDERS_DETAIL.FAILURE:
      return {
        ...state,
        order: {
          data: {
            list: []
          },
          loading: false,
          error: payload
        }
      };

    default:
      return state;
  }
};

export default Authenticate;
